import { MessageOverview } from "../../../../../../components/Messages";

const Overview = () => {
  return <MessageOverview />;
};

export default Overview;
